//#region src/runtime-coordinator-reason-code.ts
const RUNTIME_COORDINATOR_ACCEPTED_DISPATCH_PAYLOAD_CONFLICT_REASON_CODE = "runtime_coordinator.head_authority_conflict.accepted_dispatch_payload";
const RUNTIME_COORDINATOR_RETIRED_TERMINAL_HEAD_REDRIVE_REASON_CODE = "runtime_coordinator.retired_terminal_head_redrive_already_recorded";
//#endregion
export { RUNTIME_COORDINATOR_ACCEPTED_DISPATCH_PAYLOAD_CONFLICT_REASON_CODE, RUNTIME_COORDINATOR_RETIRED_TERMINAL_HEAD_REDRIVE_REASON_CODE };

//# sourceMappingURL=runtime-coordinator-reason-code.js.map